import styles from "./Account.module.css";
import { useState, useEffect } from "react";
import { useMoralis } from "react-moralis";
import Button from "../misc/Button/Button";
import { truncate } from "../../utils/general";
import Popover from "@material-ui/core/Popover";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import { AiOutlineQuestionCircle } from "react-icons/ai"
import { FiMoreHorizontal} from "react-icons/fi"

const Account = (props) => {
  const [promptUserToEnableWeb3, setPromptUserToEnableWeb3] = useState(false);
  const { switchTheme, theme}= props
    
    const [anchorEl, setAnchorEl] = useState(null);


  const {
    authenticate,
    isAuthenticated,
    isWeb3Enabled,
    isWeb3EnableLoading,
    enableWeb3,
    account,
    logout,
    user,
  } = useMoralis();
    
  let accountAdress;
  function getAccount() {
    if (isAuthenticated && isWeb3Enabled && account) {
      accountAdress = account;
    } else {
      accountAdress = 'randomAccount';
    }
    return truncate(accountAdress, 12);
  }

  let resultAddress = getAccount();

  async function handleWeb3Enable() {
    const connectorId = window.localStorage.getItem("connectorId");

    enableWeb3({ provider: connectorId });

    setPromptUserToEnableWeb3(false);
  }

  useEffect(() => {
    (async () => {
      if (promptUserToEnableWeb3) {
        handleWeb3Enable();
        return;
      }

      try {
        if (user && !account) {
          handleWeb3Enable();
        }
      } catch (error) {
        console.log(error);
      }
    })();

    // eslint-disable-next-line
  }, [promptUserToEnableWeb3, isAuthenticated, isWeb3Enabled]);

  useEffect(() => {
    if (!account && isAuthenticated && !isWeb3EnableLoading) {
      console.log("logging out");
      logout();
    }
    // eslint-disable-next-line
  }, [account]);

  const onLoginM = async () => {
    try {
      await authenticate({
        signingMessage: "CrocSwap API Authentication.",
        onSuccess: () => {
          setPromptUserToEnableWeb3(true);
          // alert('🎉');
        },
        onError: () => {
          // alert('error');
          authenticate({
            signingMessage: "CrocSwap API Authentication.",
            onSuccess: () => {
              setPromptUserToEnableWeb3(true);
              // alert('🎉');
            },
          });
        },
      });
    } catch (e) {
      console.error(e);
    }

    window.localStorage.setItem("connectorId", "injected");
  };

  const onLogout = () => {
    logout();
    window.localStorage.removeItem("connectorId");
    // setCurrentProvider(null);
  };
    
  const handlePopoverClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  
  const handlePopoverClose = () => {
    setAnchorEl(null);
  };
  
  const open = Boolean(anchorEl);
    const popoverId = open ? 'simple-popover' : undefined;
    
    const popperContent = (
        <div className={styles.popperContent}>
            <div className={styles.more_row}>
                <span>About</span>
            </div>
            <div className={styles.more_row}>
                <span>Help Center</span>
            </div>
            <div className={styles.more_row}>
                <span>Request Features</span>
            </div>
            <div className={styles.more_row}>
                <span>Discord</span>
            </div>
            <div className={styles.more_row}>
                <span>Language</span>
            </div>
            <div className={styles.more_row} onClick={switchTheme}>
                <span>{theme === "dark" ? "Light" : "Dark"} Theme</span>
            </div>
            <div className={styles.more_row}>
                <span>Docs</span>
            </div>
            <div className={styles.more_row}>
                <span>Legal & Privacy</span>
            </div>
            <Button title="Logout"/>
        </div>
    )
  return (
    <div className={styles.navbar__sign}>
      <div>
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/6f/Ethereum-icon-purple.svg/480px-Ethereum-icon-purple.svg.png"
          alt="ethereum"
          width="25px"
        />
      </div>
      <div className={styles.title_gradient}>69 AMBI</div>
      <div>69,420 ETH</div>
      {/* <div className={styles.title_gradient}>{useLocalStorage("ambientHandle")}</div> */}
      <div className={styles.title_gradient}>username</div>
      <AiOutlineQuestionCircle  size={20} />
      {isAuthenticated && isWeb3Enabled ? (
        <div>username</div>
      ) : (
        null
      )}
          <div className={styles.more}
              aria-describedby={popoverId}
              onClick={handlePopoverClick}


          >
       <FiMoreHorizontal  size={20}/>
          </div>
          <Popover
        popoverId={popoverId}
        open={open}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
              {popperContent}
      </Popover>
    </div>
  );
};

export default Account;
